module.exports = __webpack_public_path__ + "static/media/google-over.e0d92231.svg";